import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import InfoSection from '~/src/features/payments-abn/components/InfoSection';
import { pushDataLayer } from '~/src/features/payments-abn/helpers/pushDataLayer';
import { TState } from '~/src/store';

import AutoPayInfo from './autoPayInfo';

import { Agreement, Balance, SetupButton } from './styled';

const AgreementInfo: FC = ({ children }) => {
    const { clientPayment, clientPersonal } = useSelector((state: TState) => state.auth);

    const isTablet = useMatchMedia(`(max-width: ${wideBreakpoints.tablet})`);
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const { balance, bindingCards, paySum, payIsDeny } = clientPayment || {};
    const { agreement } = clientPersonal || {};

    const { autoPayStatus, comingPayDay } = bindingCards?.find(card => !!card.autoPayStatus) || {};

    return (
        <InfoSection
            isAccordion={isTablet}
            title={payIsDeny ? 'Услуги активны' : 'Услуги не активны'}
            defaultOpen={!isMobile}
        >
            <InfoSection.Content isAccordion={isTablet}>
                <AutoPayInfo
                    autoPayStatus={autoPayStatus}
                    comingPayDay={comingPayDay}
                    paySum={paySum}
                >
                    {children}
                </AutoPayInfo>
                <Balance>Баланс: {balance} {RubleSymbol}</Balance>
                <SetupButton
                    type={btnTypes.SECONDARY}
                    size={isTablet ? btnSizes.MIDDLE : btnSizes.LARGE}
                    text={'История баланса'}
                    href={'/lk/balance-history'}
                    iconsSprite={'/static/images/icons/payment-sprite.svg'}
                    symbolId={'right-arrow'}
                    onClick={() => pushDataLayer('click on balance history', 'click')}
                />
                <Agreement>Договор {agreement}</Agreement>
            </InfoSection.Content>
        </InfoSection>
    );
};

export default AgreementInfo;
